import script from "./RaceOct2025.vue?vue&type=script&setup=true&lang=js"
export * from "./RaceOct2025.vue?vue&type=script&setup=true&lang=js"

import "./RaceOct2025.vue?vue&type=style&index=0&id=109e03c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-109e03c4"]])

export default __exports__